<template>
  <div class="d-ib">
    <el-button
      type="primary"
      class="btn-main"
      icon="el-icon-search"
      @click="setDialogFilter(true)"
    >
      Claims Filter
    </el-button>
    <el-dialog
      title="Filters"
      :visible="dialog_filter"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setDialogFilter(false)"
    >
      <el-input type="text" v-model="title" placeholder="Title" clearable />
      <el-input type="text" v-model="videoId" placeholder="Video Id" class="mt10" clearable />
      <el-input type="text" v-model="keyword" placeholder="Keyword" class="mt10" clearable />
      <el-date-picker
          style="width: 100%; margin-top: 15px"
          v-model="date_range"
          type="daterange"
          format="d MMMM yyyy"
          value-format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="Start Date"
          end-placeholder="End Date"
      ></el-date-picker>
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear()">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  data() {
    return {
      title: '',
      videoId: '',
      keyword: '',
      date_range: ''
    }
  },
  computed: {
    ...mapState('youtubeClaimLog', ['dialog_filter'])
  },
  methods: {
    ...mapMutations('youtubeClaimLog', ['setDialogFilter', 'setFilter', 'setPage']),
    ...mapActions('youtubeClaimLog', ['getTodayClaims']),

    filter() {
      this.setFilter({
        title: this.title,
        videoId: this.videoId,
        keyword: this.keyword,
        dateStart: this.date_range[0],
        dateEnd: this.date_range[1],
      })
      this.setPage(1)
      this.getTodayClaims()
      this.setDialogFilter(false)
    },

    clear() {
      this.setFilter({})
      this.getTodayClaims()
      this.title = ''
      this.keyword = ''
      this.date_range = ''
      this.setDialogFilter(false)
    }
  }
}
</script>
